import { config } from "config";

export const isOnboardingComplete = (value) =>
  value === 1 || value === true || value === "1";

export const UNIFIED_DASHBOARD_PATH = "/customer/dashboard";
export const HOLDINGS_HUB_PATH = "/customer/holdings";
export const MARKET_PULSE_HUB_PATH = "/customer/market-pulse";

export const ESSENTIAL_PRODUCTS = [
  {
    id: "portfolio",
    code: config.productCodes.PORTFOLIO,
    name: "Portfolio",
    subtitle: "Model portfolio matched to your risk profile for long-term wealth creation.",
    lockedSubtitle: "Model portfolio matched to your risk profile for long-term wealth creation.",
    gradient: "linear-gradient(135deg, rgba(168, 85, 247, 0) 0%, rgba(168, 85, 247, 0.2) 100%)",
    accentColor: "#A855F7",
    icon: "/images/product-info/portfolio-3d.png",
    subscriptionKey: "portfolioData",
    isOnboardedSelector: (state) => state.onboarding.isOnboardingCompleted,
    onboardingPath: "/jarvis-portfolio/onboarding/overview",
    productInfoPath: "/customer/product-info/portfolio",
    dashboardPath: "/jarvis-portfolio/dashboard",
    holdingsPath: "/jarvis-portfolio/existing-holding",
    actionCentrePath: "/jarvis-portfolio/action-centre",
    needsFirstRender: false,
    clearPlanIdOnStart: false,
  },
  {
    id: "onestock",
    code: config.productCodes.ONESTOCK,
    name: "One Stock",
    subtitle: "Stock Ideas",
    lockedSubtitle: "Stock Ideas",
    gradient: "linear-gradient(135deg, rgba(59, 130, 246, 0) 47%, rgba(59, 130, 246, 0.3) 100%)",
    accentColor: "#3B82F6",
    icon: "/images/product-info/onestock-3d.png",
    subscriptionKey: "onestockData",
    isOnboardedSelector: (state) =>
      state.jarvisOnestock.onestockOnboarding.isOnboardingCompleted,
    onboardingPath: "/jarvis-onestock/onboarding/overview",
    productInfoPath: "/customer/product-info/onestock",
    dashboardPath: "/jarvis-onestock/dashboard",
    holdingsPath: "/jarvis-onestock/existing-holding",
    actionCentrePath: "/jarvis-onestock/action-centre",
    needsFirstRender: true,
    clearPlanIdOnStart: false,
  },
  {
    id: "protect",
    code: config.productCodes.RMS,
    name: "Protect",
    subtitle: "Safeguarding Stocks",
    lockedSubtitle: "Safeguarding Stocks",
    gradient: "linear-gradient(135deg, rgba(85, 247, 123, 0) 0%, rgba(85, 247, 123, 0.2) 100%)",
    accentColor: "#22C55E",
    icon: "/images/product-info/protect-3d.png",
    subscriptionKey: "rmsData",
    isOnboardedSelector: (state) =>
      state.jarvisRMS.rmsOnboarding.isOnboardingCompleted,
    onboardingPath: "/jarvis-rms/onboarding/overview",
    productInfoPath: "/customer/product-info/protect",
    dashboardPath: "/jarvis-rms/dashboard",
    holdingsPath: "/jarvis-rms/existing-holding",
    actionCentrePath: "/jarvis-rms/action-centre",
    needsFirstRender: true,
    clearPlanIdOnStart: false,
  },
  {
    id: "phc",
    code: config.productCodes.PHC,
    name: "PHC",
    subtitle: "Free Portfolio Health Check",
    lockedSubtitle: "Free Portfolio Health Check",
    gradient: "linear-gradient(135deg, rgba(248, 74, 74, 0) 0%, rgba(248, 74, 74, 0.1) 100%)",
    accentColor: "#F84A4A",
    icon: "/images/product-info/phc-3d.png",
    subscriptionKey: "phcData",
    isOnboardedSelector: (state) => state.PHC.PHCOnboarding.isOnboardingCompleted,
    onboardingPath: "/phc/onboarding/overview",
    productInfoPath: "/customer/product-info/phc",
    dashboardPath: "/phc/dashboard",
    holdingsPath: null,
    needsFirstRender: false,
    clearPlanIdOnStart: false,
  },
];

export const PRIVATE_WEALTH_PRODUCTS = [
  {
    id: "prime",
    code: config.productCodes.PRIME,
    name: "Prime",
    subtitle: "Hyper-Personalized Portfolio Management",
    icon: "/images/product-info/prime-3d.png",
    lockedHero: "/images/product-info/private-wealth/prime-card-hero.png",
    subscriptionKey: "primeData",
    isOnboardedSelector: (state) =>
      state.jarvisPrime.primeOnboarding.isPrimeOnboardingCompleted,
    onboardingPath: "/jarvis-prime/onboarding/overview",
    productInfoPath: "/customer/product-info/prime",
    dashboardPath: "/jarvis-prime/dashboard",
    holdingsPath: "/jarvis-prime/existing-holding",
    actionCentrePath: "/jarvis-prime/action-centre",
    needsFirstRender: false,
    clearPlanIdOnStart: true,
    theme: "gold",
    sectionTab: "portfolio_management",
  },
  {
    id: "usStrategy",
    code: "US_STRATEGY",
    name: "US Strategy",
    subtitle: "Professionally Managed US Multi-Asset Allocation",
    description:
      "US Equities are complemented with tactical fixed income and selective commodities (Gold & Silver) to actively manage volatility across market cycles.",
    icon: "/images/product-info/us-strategy-globe.png",
    lockedHero: "/images/product-info/private-wealth/us-strategy-card-hero.png",
    comingSoon: true,
    theme: "navy",
    ctaLabel: "Know More",
    productInfoPath: "/customer/product-info/us-strategy",
    sectionTab: "portfolio_management",
  },
  {
    id: "atlas",
    code: config.productCodes.ATLAS || "ATLAS",
    name: "Atlas",
    subtitle: "Recommendations across 10+ Global Markets",
    icon: "/images/atlas-product-info/Atlas.png",
    lockedHero: "/images/product-info/private-wealth/atlas-card-hero.png",
    subscriptionKey: "atlasData",
    isOnboardedSelector: () => false,
    onboardingPath: "/customer/product-info/atlas",
    productInfoPath: "/customer/product-info/atlas",
    dashboardPath: "/customer/product-info/atlas",
    holdingsPath: null,
    needsFirstRender: false,
    clearPlanIdOnStart: false,
    theme: "bronze",
    forceInPortfolioTab: true,
    sectionTab: "portfolio_management",
  },
  {
    id: "sentimentTracker",
    code: config.productCodes.SENTIMENT,
    name: "Sentiment",
    subtitle: "See What the Market is About to do",
    icon: "/images/product-info/sentiment-3d.png",
    lockedHero: "/images/product-info/sentiment-3d.png",
    subscriptionKey: "sentimentData",
    isOnboardedSelector: (state) =>
      state.sentimentTracker.sentimentTrackerOnboarding.isOnboardingCompleted,
    onboardingPath: "/sentiment-tracker/onboarding/overview",
    productInfoPath: "/customer/product-info/sentiment",
    dashboardPath: "/sentiment-tracker/dashboard",
    holdingsPath: null,
    needsFirstRender: false,
    clearPlanIdOnStart: false,
    theme: "blue",
    sectionTab: "derivatives",
  },
  {
    id: "pms",
    code: "PMS",
    name: "PMS",
    subtitle: "Portfolio Management Services",
    comingSoon: true,
    hidden: true,
    theme: "teal",
    ctaLabel: "Join Waitlist",
    showComingSoonCentered: true,
    sectionTab: "portfolio_management",
  },
];

export const ALL_PRODUCTS = [
  ...ESSENTIAL_PRODUCTS,
  ...PRIVATE_WEALTH_PRODUCTS.filter((p) => !p.comingSoon && !p.hidden),
];

export const getFirstOnboardedHoldingsPath = (state) => {
  for (const product of ALL_PRODUCTS) {
    if (product.holdingsPath && isOnboardingComplete(product.isOnboardedSelector(state))) {
      return product.holdingsPath;
    }
  }
  return null;
};
